import { accessCodes } from '../../config';
import { useFlexAssessmentContext } from '../../context/context';
import Landing from './landing';
import LandingDtc from './landing-dtc';

export default function LandingContainer(): JSX.Element {
  const { state } = useFlexAssessmentContext();
  return state.accessCode === accessCodes.dtc ? <LandingDtc /> : <Landing />;
}
